import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment.development';
import { ActualizarClinica, Clinica } from '../interface/interface';

@Injectable({
  providedIn: 'root',
})
export class ClinicaService {
  private clinicaApiUrl = `${environment.apiUrl}/clinicas`;

  constructor(private http: HttpClient) {}

  obtenerClinica(): Observable<Clinica> {
    return this.http.get<Clinica>(this.clinicaApiUrl);
  }

  actualizarClinica(clinica: ActualizarClinica): Observable<{
    mensaje: string;
    data: {
      nombre: string;
      direccion: string;
      claveClinica: string;
    };
  }> {
    return this.http.patch<{
      mensaje: string;
      data: {
        nombre: string;
        direccion: string;
        claveClinica: string;
      };
    }>(this.clinicaApiUrl, clinica);
  }

  subirArchivoLogo(archivo: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', archivo);

    return this.http.post<any>(`${this.clinicaApiUrl}/logo`, formData);
  }

  obtenerArchivoLogo(): Observable<Blob> {
    return this.http.get(`${this.clinicaApiUrl}/logo`, {
      responseType: 'blob',
    });
  }
}
